import { InspectorContext } from "../reducer";
import { InspectorWeld } from "@/api/paralloy/rbi";
import { PageControls } from "../../../common/PageControls";
import { Pagination } from "@/components";
import { useContext, useState } from "react";
import { useGetWeldList } from "../queries";
import { WeldSelectionFilters } from "./WeldSelectionFilters";

const WELDS_PER_PAGE = 20;

export function WeldSelection() {
  const { state, updateState } = useContext(InspectorContext);
  const [skip, setSkip] = useState(0);

  const welds = useGetWeldList(state, skip, WELDS_PER_PAGE);

  function handleWeldSelected(e: React.FormEvent<HTMLInputElement>, weld: InspectorWeld) {
    updateState({
      type: "Welds",
      payload: e.currentTarget.checked ? [...state.welds, weld] : state.welds.filter((x) => x.weldId !== weld.weldId),
    });
  }

  if (welds.isLoading) {
    return <p>Loading welds...</p>;
  }

  return (
    <>
      <div className="text-secondary mb-4">
        {state.project?.name} / {state.subProject?.name} / {state.datasheet?.datasheetName}
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover text-center text-nowrap">
          <thead>
            <tr>
              {!state.datasheet && <th>S/A Sheet</th>}
              <th>Weld No.</th>
              <th>Assy No./Melt No A</th>
              <th>Unique ID A</th>
              <th>Assy No./Melt No B</th>
              <th>Unique ID B</th>
              <th>Ready For</th>
              {welds.data?.results.some((x) => x.drawingId) && <th>Weld Map</th>}
              <th>
                {welds.data && welds.data.results.length > 1 && (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={state.welds.length === welds.data.results.length}
                    onChange={(e) => {
                      updateState({
                        type: "Welds",
                        payload: e.currentTarget.checked ? welds.data.results : [],
                      });
                    }}
                  />
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {welds.data?.results.map((weld, index) => (
              <tr key={index}>
                {!state.datasheet && <td>{weld.datasheet}</td>}
                <td>{weld.weldNumber}</td>
                <td>{weld.meltNumberA}</td>
                <td>{weld.uniqueIdA}</td>
                <td>{weld.meltNumberB}</td>
                <td>{weld.uniqueIdB}</td>
                <td>{weld.techniques}</td>
                {welds.data?.results.some((x) => x.drawingId) && (
                  <td>
                    {weld.drawingId && (
                      <a
                        href={`drawing/${weld.drawingId}?weldId=${weld.weldId}`}
                        target="_blank"
                        className="link-primary"
                      >
                        View
                      </a>
                    )}
                  </td>
                )}
                <td>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={state.welds.some((e) => e.weldId === weld.weldId)}
                    onChange={(e) => handleWeldSelected(e, weld)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex flex-sm-row flex-column justify-content-between">
        <WeldSelectionFilters />
        <div>
          {welds.data && welds.data.total > WELDS_PER_PAGE && (
            <Pagination
              current={welds.data.page}
              total={welds.data.total}
              count={welds.data.results.length}
              pageSize={WELDS_PER_PAGE}
              onPageChanged={setSkip}
            />
          )}

          <PageControls showBack showNext allowNext={state.welds.length > 0} />
        </div>
      </div>
    </>
  );
}
